import app from '@/app';
import templateUrl from './road-import-dialog.html';

/* @ngInject */
function Controller($translate, Upload, Principal, $scope, $filter) {
	var $ctrl = this;

	$ctrl.$onInit = () => {
		$ctrl.step = 'SELECTION';
		$ctrl.loadingExcel = true;
		$ctrl.uniqueOrgs = [];
		$ctrl.selectedOrgs = {};

		$ctrl.currentAccount = null;

		Principal.identity().then(account => {
			$ctrl.currentAccount = account;
		});

		if ($ctrl.resolve.files && $ctrl.resolve.files.length > 0) {
			const file = $ctrl.resolve.files[0];
			const reader = new FileReader();
			reader.onload = (e) => {
				try {
					const data = new Uint8Array(e.target.result);
					const workbook = window.XLSX.read(data, {type: 'array'});
					const firstSheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[firstSheetName];
					const json = window.XLSX.utils.sheet_to_json(worksheet, {header: 1});

					const organizations = new Set();
					// Começa a ler na linha 3 (índice 2)
					for (let i = 2; i < json.length; i++) {
						if (json[i] && json[i][0] && typeof json[i][0] === 'string' && json[i][0].trim() !== '') {
							organizations.add(json[i][0].trim());
						}
					}
					$ctrl.uniqueOrgs = Array.from(organizations).sort();
					$ctrl.uniqueOrgs.forEach(org => $ctrl.selectedOrgs[org] = true);
				} catch (err) {
					console.error("Error reading excel", err);
				} finally {
					$ctrl.loadingExcel = false;
					$scope.$applyAsync();
				}
			};
			reader.readAsArrayBuffer(file);
		} else {
			$ctrl.loadingExcel = false;
		}
	};

	$ctrl.hasSelectedOrgs = () => {
		return Object.keys($ctrl.selectedOrgs).some(org => $ctrl.selectedOrgs[org]);
	};

	$ctrl.selectAllFiltered = () => {
		const filtered = $filter('filter')($ctrl.uniqueOrgs, $ctrl.orgFilter);
		filtered.forEach(org => {
			$ctrl.selectedOrgs[org] = true;
		});
	};

	$ctrl.deselectAllFiltered = () => {
		const filtered = $filter('filter')($ctrl.uniqueOrgs, $ctrl.orgFilter);
		filtered.forEach(org => {
			$ctrl.selectedOrgs[org] = false;
		});
	};

	$ctrl.startImport = () => {
		$ctrl.step = 'UPLOADING';
		const selected = Object.keys($ctrl.selectedOrgs).filter(org => $ctrl.selectedOrgs[org]);

		$ctrl.uploading = $ctrl.resolve.files.length;
		$ctrl.resolve.files.forEach(file => {
			file.progress = 0;
		});

		$ctrl.resolve.files.forEach(file => {
			file.upload = Upload.upload({
				url: '/api/roads/import/excel',
				data: { file: file, organizations: selected.join(';')}
			});

			file.upload.then(onSuccess, onError, onProgress);

			function onSuccess(response) {
				--$ctrl.uploading;
				file.progress = 100.0;
				file.result = 'success';
        file.message = $translate.instant('road.geometry.import.start', { 'name': file.name });
			}

			function onError(response) {
				--$ctrl.uploading;
				file.progress = 100.0;
				if (response.data && response.data.errors) {
					file.errors = response.data.errors;
				} else if (response.data && response.data.message) {
					file.errors = [$translate.instant(response.data.message)];
				} else {
					file.errors = [$translate.instant('message.unexpectedError')];
				}
				file.result = 'danger';
			}

			function onProgress(event) {
				file.progress = Math.min(100, parseInt((90.0 * event.loaded) / event.total));
			}
		});
	};
}

app.component('roadImportDialog', {
	templateUrl,
	controller: Controller,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});
